import { AxisRenderer } from '@amcharts/amcharts5/xy';
import { Injectable } from '@angular/core';
import {
    emptyDatiqGraphGridX,
    emptyDatiqGraphGridY,
    IDatiqGraphGrid,
} from '../models';
import { isNumber } from 'lodash';
import { DatiqAmcharts5UtilsService } from './datiq-amcharts-5-utils.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqAmcharts5GridService {
    constructor(private _utils: DatiqAmcharts5UtilsService) {}

    setGridTemplateY(
        renderer: AxisRenderer,
        grid: Partial<IDatiqGraphGrid>
    ): AxisRenderer {
        const gridY: Partial<IDatiqGraphGrid> = this.getGridY(grid);

        return this.setUpGrid(renderer, gridY);
    }
    setGridTemplateX(
        renderer: AxisRenderer,
        grid: Partial<IDatiqGraphGrid>
    ): AxisRenderer {
        const gridX: Partial<IDatiqGraphGrid> = this.getGridX(grid);

        return this.setUpGrid(renderer, gridX);
    }
    getGridX(grid: Partial<IDatiqGraphGrid>): Partial<IDatiqGraphGrid> {
        return {
            ...emptyDatiqGraphGridX,
            ...(grid ?? {}),
        };
    }

    setUpGrid(
        renderer: AxisRenderer,
        grid: Partial<IDatiqGraphGrid>
    ): AxisRenderer {
        return this.setGridTemplateStroke(renderer, grid)
            .setGridTemplateStrokeWidth(renderer, grid)
            .setGridTemplateStrokeOpacity(renderer, grid)
            .setGridTemplateStrokeDashArray(renderer, grid)
            .build(renderer);
    }

    setGridTemplateStrokeDashArray(
        renderer: AxisRenderer,
        grid: Partial<IDatiqGraphGrid>
    ): this {
        isNumber(grid?.strokeDasharray) || Array.isArray(grid?.strokeDasharray)
            ? renderer.grid.template.set(
                  'strokeDasharray',
                  grid?.strokeDasharray
              )
            : renderer;

        return this;
    }

    setGridTemplateStrokeOpacity(
        renderer: AxisRenderer,
        grid: Partial<IDatiqGraphGrid>
    ): this {
        isNumber(grid?.strokeOpacity)
            ? renderer.grid.template.set('strokeOpacity', grid?.strokeOpacity)
            : renderer;

        return this;
    }
    setGridTemplateStrokeWidth(
        renderer: AxisRenderer,
        grid: Partial<IDatiqGraphGrid>
    ): this {
        isNumber(grid?.strokeWidth)
            ? renderer.grid.template.set('strokeWidth', grid?.strokeWidth)
            : renderer;

        return this;
    }
    getGridY(grid: Partial<IDatiqGraphGrid>): Partial<IDatiqGraphGrid> {
        return {
            ...emptyDatiqGraphGridY,
            ...(grid ?? {}),
        };
    }

    setGridTemplateStroke(
        renderer: AxisRenderer,
        grid: Partial<IDatiqGraphGrid>
    ): this {
        !!grid?.stroke?.length
            ? renderer.grid.template.set(
                  'stroke',
                  this._utils.setColor(grid?.stroke)
              )
            : renderer;

        return this;
    }

    build(renderer: AxisRenderer): AxisRenderer {
        return renderer;
    }
}
